import { styled } from "@mui/material/styles";

// Components
import { Typography } from "@mui/material";
import { theme } from "~/components/Common";

const styledName = "WalletInfo";

export const StyledCateView = styled(Typography, { name: styledName })({
  "&": {
    margin: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "all 0.3s ease-in",
    ":hover": {
      color: theme.palette.primary.main,
    },
  },
});
